import '/src/styles.css';
import * as React from 'react';
export default {
  React
};